import React from 'react';
import {Button, Clearfix, Panel} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import GreenLeafApi from '../utils/GreenLeafApi';
import ItemList from '../ItemList';
import ErrorComponent from '../ErrorComponent';
import {connect} from 'react-redux';
import {clearErrors, getCompanies} from '../utils/actions';
import {deleteCompany} from '../utils/actions/companies';

class CompaniesPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.fetchCompanies = this.fetchCompanies.bind(this);
  }

  componentWillMount() {
    this.props.clearError();
    this.tableOptions = {
      tableHeaders: ['Name'],
      tableData: ['name'],
      editItem: (company) => this.props.history.push(`/companies/${company.id}/edit`),
      deleteItem: (company) => this.props.deleteCompany(company.id),
      goToItemDashboard: (company) => this.props.history.push(`/companies/${company.id}`)
    };
  }

  async componentDidMount() {
    try {
      await this.fetchCompanies();
    } catch(e) {
      this.setState({errors: e.errors});
    }
  }

  async fetchCompanies() {
    let user = this.props.auth.userInfo;

    if (user.attributes['custom:role'] === 'admin') {
      this.props.fetchCompanies();
    } else {
      let companyUsers = (await GreenLeafApi.CompanyUser.get({ email: user.username.replace('+', '%2B') })).data;
      companyUsers.forEach(async cu => {
        this.props.fetchCompanies({ id: cu.company_id });
      });
    }
  }

  render() {
    const companies = Object.values(this.props.companies.data);

    return (
      <div>
        <ErrorComponent error={[...this.state.errors, ...this.props.errors]}/>
        <Panel>
          <Panel.Heading>
            <Panel.Title componentClass="h3" className={'relative'}>
              <div className={'float-vertical-align pull-left'}>Companies</div>
              <div className={'pull-right'}>
                <Link className={'pull-right'} to={'/companies/create'}>
                  <Button data-cy="create-company" className={'primary'}>Create</Button>
                </Link>
              </div>
              <Clearfix/>
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <ItemList
              options={this.tableOptions}
              items={companies}
            />
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

const mapStateToProps = state => ({ companies: state.companies, errors: state.errors });

const mapDispatchToProps = dispatch => ({
  fetchCompanies: (query) => dispatch(getCompanies(query)),
  deleteCompany: (id) => dispatch(deleteCompany(id)),
  clearError: () => dispatch(clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesPanel);



// WEBPACK FOOTER //
// ./src/components/company/CompaniesPanel.js